import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import SuccessRole from '../charts/SuccessRole';
import SuccessTech from '../charts/SuccessTech';
import {
  StyledCard,
  StyledCardTitle,
  StyledContainer,
  StyledContent,
  StyledData,
  StyledDataItem,
  StyledHeader,
  StyledHighlight,
  StyledHighlightList,
  StyledHighlightValue,
  StyledValue,
  StyledValueNumber,
  StyledWrapper
} from './SuccessRate.styled';

const SuccessRateData: React.FC = () => {
  const { t } = useI18n('state-of-hiring');

  const locationData = [
    {
      value: 59,
      desc: t('state-of-hiring.success-rate.location.on-site')
    },
    {
      value: 74,
      desc: t('state-of-hiring.success-rate.location.remote')
    }
  ];

  const seniorityData = [
    {
      value: 75,
      desc: t('state-of-hiring.success-rate.seniority.senior')
    },
    {
      value: 75,
      desc: t('state-of-hiring.success-rate.seniority.mid-level')
    },
    {
      value: 87,
      desc: t('state-of-hiring.success-rate.seniority.junior')
    }
  ];

  const reasonsData = [
    {
      value: 30,
      desc: t('state-of-hiring.success-rate.reasons.on-hold')
    },
    {
      value: 20,
      desc: t('state-of-hiring.success-rate.reasons.external-reasons')
    },
    {
      value: 16,
      desc: t('state-of-hiring.success-rate.reasons.no-value')
    },
    {
      value: 10,
      desc: t('state-of-hiring.success-rate.reasons.internal-hire')
    },
    {
      value: 7,
      desc: t('state-of-hiring.success-rate.reasons.no-need')
    },
    {
      value: 7,
      desc: t('state-of-hiring.success-rate.reasons.other-person')
    },
    {
      value: 4,
      desc: t('state-of-hiring.success-rate.reasons.no-understanding')
    },
    {
      value: 2,
      desc: t('state-of-hiring.success-rate.reasons.no-answer')
    },
    {
      value: 1,
      desc: t('state-of-hiring.success-rate.reasons.other-agency')
    },
    {
      value: 1,
      desc: t('state-of-hiring.success-rate.reasons.too-expensive')
    },
    {
      value: 1,
      desc: t('state-of-hiring.success-rate.reasons.candidate-rejection')
    },
    {
      value: 1,
      desc: t('state-of-hiring.success-rate.reasons.closed-position')
    }
  ];

  return (
    <StyledWrapper className="notice">
      <StyledContainer>
        <StyledHeader>
          <Heading2 editorial>
            {t('state-of-hiring.success-rate.title')}
          </Heading2>
          <p>
            <HtmlTrans
              i18nKey="state-of-hiring.success-rate.desc"
              ns="state-of-hiring"
            />
          </p>
        </StyledHeader>
        <StyledContent>
          <div>
            <StyledCard>
              <StyledCardTitle>
                {t('state-of-hiring.success-rate.rol.title')}
              </StyledCardTitle>
              <SuccessRole />
            </StyledCard>
          </div>
          <div>
            <StyledHighlightList>
              <StyledHighlight>
                <StyledHighlightValue>72%</StyledHighlightValue>
                <span>{t('state-of-hiring.success-rate.manfred')}</span>
              </StyledHighlight>
              <StyledHighlight>
                <StyledHighlightValue>72%</StyledHighlightValue>
                <span>{t('state-of-hiring.success-rate.recurrent')}</span>
              </StyledHighlight>
            </StyledHighlightList>
            <StyledCard>
              <StyledCardTitle>
                {t('state-of-hiring.success-rate.location.title')}
              </StyledCardTitle>
              <StyledData>
                {locationData.map((item, index) => (
                  <StyledDataItem key={index}>
                    <StyledValue>
                      <StyledValueNumber>{item.value}%</StyledValueNumber>
                    </StyledValue>
                    <span>{item.desc}</span>
                  </StyledDataItem>
                ))}
              </StyledData>
            </StyledCard>
          </div>
        </StyledContent>
        <StyledContent className="reverse">
          <div>
            <StyledCard>
              <StyledCardTitle>
                {t('state-of-hiring.success-rate.seniority.title')}
              </StyledCardTitle>
              <StyledData>
                {seniorityData.map((item, index) => (
                  <StyledDataItem key={index}>
                    <StyledValue>
                      <StyledValueNumber>{item.value}%</StyledValueNumber>
                    </StyledValue>
                    <span>{item.desc}</span>
                  </StyledDataItem>
                ))}
              </StyledData>
            </StyledCard>
            <StyledHighlight>
              <StyledHighlightValue>4%</StyledHighlightValue>
              <span>{t('state-of-hiring.success-rate.rejections')}</span>
            </StyledHighlight>
          </div>
          <div>
            <StyledCard>
              <StyledCardTitle>
                {t('state-of-hiring.success-rate.tech.title')}
              </StyledCardTitle>
              <SuccessTech />
            </StyledCard>
          </div>
        </StyledContent>
        <StyledHighlightList>
          <StyledCardTitle>
            {t('state-of-hiring.success-rate.reasons.title')}
          </StyledCardTitle>
          {reasonsData.map((item, index) => (
            <StyledHighlight key={index}>
              <StyledHighlightValue>{item.value}%</StyledHighlightValue>
              <span>{item.desc}</span>
            </StyledHighlight>
          ))}
        </StyledHighlightList>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default SuccessRateData;
